import { render } from "./StatusModalFail.vue?vue&type=template&id=013f771d&scoped=true"
import script from "./StatusModalFail.vue?vue&type=script&lang=js"
export * from "./StatusModalFail.vue?vue&type=script&lang=js"

import "./StatusModalFail.vue?vue&type=style&index=0&id=013f771d&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013f771d"]])

export default __exports__